import script from "./CrudRefacciones.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudRefacciones.vue?vue&type=script&setup=true&lang=js"

import "./CrudRefacciones.vue?vue&type=style&index=0&id=79fe8e16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79fe8e16"]])

export default __exports__